import Router from 'vue-router'
import ManageUsers from '@/pages/ManageUsers'
import ManageClients from '@/pages/ManageClients'
import ManageClientDatabases from '@/pages/ManageClientDatabases'
import ManageClientDocuments from '@/pages/ManageClientDocuments'
import ManageUserGroups from '@/pages/ManageUserGroups'
import ManageRoles from '@/pages/ManageRoles'
import ManageOktaUsers from '@/pages/ManageOktaUsers'
import ManageOktaFederations from '@/pages/ManageOktaFederations'

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      alias: '/users',
      name: 'manage-users',
      component: ManageUsers,
      props: route => ({ login: route.query.login })
    },
    {
      path: '/user-groups',
      name: 'manage-user-groups',
      component: ManageUserGroups
    },
    {
      path: '/roles',
      name: 'manage-roles',
      component: ManageRoles
    },
    {
      path: '/clients',
      name: 'manage-clients',
      component: ManageClients
    },
    {
      path: '/client-databases',
      name: 'manage-client-databases',
      component: ManageClientDatabases
    },
    {
      path: '/okta-users',
      name: 'manage-okta-users',
      component: ManageOktaUsers,
      props: route => ({ login: route.query.login })
    },
    {
      path: '/okta-federations',
      name: 'manage-okta-federations',
      component: ManageOktaFederations
    },
    {
      path: '/client-documents',
      name: 'manage-client-documents',
      component: ManageClientDocuments
    }
  ]
})
